import { UserRound } from "lucide-react";
import type { ImgHTMLAttributes } from "react";
import {
  ProtectedImage,
  type ProtectedPhotoVariant,
} from "./ProtectedImage";

export function ProfilePhoto({
  photoId,
  variant = "thumbnail",
  alt = "",
  className = "",
  ...imageProps
}: Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  photoId?: string | null;
  variant?: ProtectedPhotoVariant;
}) {
  return (
    <span
      className={`profile-picture-shell${className ? ` ${className}` : ""}`}
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
    >
      <span className="profile-picture-fallback" aria-hidden="true">
        <UserRound />
      </span>
      {photoId && (
        <ProtectedImage
          {...imageProps}
          photoId={photoId}
          variant={variant}
          alt=""
          className="profile-picture-image"
        />
      )}
    </span>
  );
}
